import {Component, OnInit} from '@angular/core';
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {MatCommonModule} from '@angular/material/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [],
  imports: [
    RouterModule,
    CommonModule,
    MatCommonModule,
  ],
  providers: [
    {
      provide: HttpClient,
      useFactory: () => provideHttpClient(withInterceptorsFromDi())
    }]
})
export class AppComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
